import Vue from 'vue'
import Vuex from 'vuex'
import user from './user'
import common from './common'
Vue.use(Vuex)

export default new Vuex.Store({
  getters: {
    userInfo: state => (state.user.userInfo ? JSON.parse(state.user.userInfo) : ''),
    userType: state => {
      // 登录用户类型 expert=专家 company=机构 individual=普通个人
      // if (state.user.userInfo === '') return ''
      // const userInfo = JSON.parse(state.user.userInfo)
      // if (userInfo.isInvitedExpert) { // 特邀专家
      //   return 'expert'
      // } else if (userInfo.type === 'INDIVIDUAL') {
      //   if (userInfo.status === 'PASS' || userInfo.status === 'CANCEL_REJECT' || userInfo.status === 'CANCELING') {
      //     return 'expert' // 专家账号
      //   }
      //   return 'individual' // 普通个人账号
      // } else if (userInfo.type === 'ENTERPRISE') {
      //   return userInfo.id === '20180311064' ? 'company' : 'enterprise' // company=机构账号 enterprise=企业账号
      // } else if (userInfo.type === 'SYSTEM') {
      //   return 'base' // 基地
      // } else {
      //   return ''
      // }
      return ''
    },
    token: state => state.user.token,
    currentMenuObj: state => state.common.currentMenuObj,
    companyDetail: state => state.common.companyDetail,
    companyAccountDetail: state => state.common.companyAccountDetail,
    individualAccountDetail: state => state.common.individualAccountDetail,
    langType: state => state.common.langType,
    showLoginDialog: state => state.common.showLoginDialog
  },
  modules: {
    user,
    common
  }

  // state: {
  //   showLoginDialog: false
  // },
  // mutations: {
  //   // 设置展示语言类型
  //   SET_LOGIN_DIALOG: async (state, status) => {
  //     state.showLoginDialog = status
  //     localStorage.setItem('showLoginDialog', status)
  //   }
  // },
  // actions: {
  //   SetLoginDialog: ({ commit }, status) => {
  //     commit('SET_LOGIN_DIALOG', status)
  //   }
  // }
})
